"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomMenuDropdown = void 0;
var react_1 = __importStar(require("react"));
var icons_1 = require("../../../constants/icons");
var useOnClickOutside_1 = require("../../../hooks/useOnClickOutside");
var dropdown_1 = require("../../../types/dropdown");
var molecules_1 = require("../../molecules");
var LabelInsideControlAndTooltip_1 = __importDefault(require("./LabelInsideControlAndTooltip"));
var DRODPWN_SIZE_STYLES = (_a = {},
    _a[dropdown_1.DROPDOWN_SIZE_TYPES.LARGE] = {
        controlClassName: 'tw-rounded-[5px] tw-h-[72px] tw-py-6 tw-px-6',
        dropdownDimensions: {
            width: 24,
            height: 24,
        },
        valueClassName: 'f-16-300',
    },
    _a[dropdown_1.DROPDOWN_SIZE_TYPES.MEDIUM] = {
        controlClassName: 'tw-rounded-[5px] tw-h-[52px] tw-py-4 tw-px-6',
        dropdownDimensions: {
            width: 20,
            height: 20,
        },
        valueClassName: 'f-16-300',
    },
    _a[dropdown_1.DROPDOWN_SIZE_TYPES.SMALL] = {
        controlClassName: 'tw-rounded-[5px] tw-h-11 tw-py-3 tw-px-6',
        dropdownDimensions: {
            width: 16,
            height: 16,
        },
        valueClassName: 'f-16-300',
    },
    _a[dropdown_1.DROPDOWN_SIZE_TYPES.SMALLEST] = {
        controlClassName: 'tw-rounded tw-h-[35px] tw-py-2.5 tw-px-2',
        dropdownDimensions: {
            width: 12,
            height: 12,
        },
        valueClassName: 'f-16-300',
    },
    _a[dropdown_1.DROPDOWN_SIZE_TYPES.XSMALL] = {
        controlClassName: 'tw-rounded tw-h-[27px] tw-py-2.5 tw-px-2',
        dropdownDimensions: {
            width: 12,
            height: 12,
        },
        valueClassName: 'f-12-300',
    },
    _a);
var CustomMenuDropdown = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.resetText, resetText = _c === void 0 ? 'Reset filters' : _c, _d = _a.resetClassName, resetClassName = _d === void 0 ? '' : _d, _e = _a.resetTextClassName, resetTextClassName = _e === void 0 ? '' : _e, onReset = _a.onReset, eventCallback = _a.eventCallback, id = _a.id, title = _a.title, leadingIconProps = _a.leadingIconProps, _f = _a.menuWrapperClassName, menuWrapperClassName = _f === void 0 ? '' : _f, value = _a.value, tooltipBody = _a.tooltipBody, selectedCount = _a.selectedCount, _g = _a.size, size = _g === void 0 ? dropdown_1.DROPDOWN_SIZE_TYPES.MEDIUM : _g, _h = _a.controlClassName, controlClassName = _h === void 0 ? 'tw-bg-BASE_SECONDARY' : _h, _j = _a.placeholder, placeholder = _j === void 0 ? 'Placeholder' : _j, _k = _a.borderClassName, borderClassName = _k === void 0 ? 'tw-border-ZAMP_PRIMARY' : _k, _l = _a.useExternalWrapper, useExternalWrapper = _l === void 0 ? false : _l, _m = _a.triggerClose, triggerClose = _m === void 0 ? 0 : _m, _o = _a.childrenWrapperClassName, childrenWrapperClassName = _o === void 0 ? '' : _o, _p = _a.disabled, disabled = _p === void 0 ? false : _p, _q = _a.customControl, customControl = _q === void 0 ? function () { return null; } : _q, _r = _a.hideIndicator, hideIndicator = _r === void 0 ? false : _r, _s = _a.selectedCountClassName, selectedCountClassName = _s === void 0 ? '' : _s, onToggleOpen = _a.onToggleOpen;
    var _t = react_1.useState(false), isOpen = _t[0], setIsOpen = _t[1];
    var toggleOpen = function () { return !disabled && setIsOpen(function (prev) { return !prev; }); };
    var ref = react_1.useRef(null);
    useOnClickOutside_1.useOnClickOutside(ref, function () { return setIsOpen(false); });
    react_1.useEffect(function () {
        setIsOpen(false);
    }, [triggerClose]);
    react_1.useEffect(function () {
        onToggleOpen === null || onToggleOpen === void 0 ? void 0 : onToggleOpen(isOpen);
    }, [isOpen, onToggleOpen]);
    return (react_1.default.createElement("div", { className: className, ref: ref },
        react_1.default.createElement("div", { className: "tw-border tw-flex tw-justify-between hover:" + borderClassName + " tw-items-center " + DRODPWN_SIZE_STYLES[size].controlClassName + " " + (isOpen ? borderClassName : 'tw-border-DIVIDER_GRAY') + " " + controlClassName, onClick: toggleOpen, "data-testid": "custom-menu-dropdown-control-" + id },
            customControl(isOpen, toggleOpen) ||
                (title ? (react_1.default.createElement(LabelInsideControlAndTooltip_1.default, { tooltipBody: tooltipBody, title: title, leadingIconProps: leadingIconProps, selectedCount: selectedCount, id: id, selectedCountClassName: selectedCountClassName })) : (react_1.default.createElement(react_1.default.Fragment, null, value ? (react_1.default.createElement("div", { className: "tw-select-none " + DRODPWN_SIZE_STYLES[size].valueClassName, "data-testid": "custom-menu-dropdown-control-value-" + id }, value)) : (react_1.default.createElement("div", { className: "tw-select-none tw-text-TEXT_TERTIARY " + DRODPWN_SIZE_STYLES[size].valueClassName, "data-testid": "custom-menu-dropdown-control-placeholder-" + id }, placeholder))))),
            !hideIndicator && (react_1.default.createElement(molecules_1.SvgSpriteLoader, { id: 'chevron-down', iconCategory: icons_1.ICON_SPRITE_TYPES.ARROWS, width: DRODPWN_SIZE_STYLES[size].dropdownDimensions.width, height: DRODPWN_SIZE_STYLES[size].dropdownDimensions.height }))),
        isOpen &&
            (useExternalWrapper ? (children) : (react_1.default.createElement(molecules_1.MenuWrapper, { className: "tw-my-2 !tw-absolute tw-w-full " + menuWrapperClassName, resetText: resetText, resetClassName: resetClassName, resetTextClassName: resetTextClassName, onReset: onReset, eventCallback: eventCallback, id: id, childrenWrapperClassName: childrenWrapperClassName }, children)))));
};
exports.CustomMenuDropdown = CustomMenuDropdown;
